import { createActionCreator } from 'deox';
import { PlacementConfig } from '../models/placement-config.model';
import { PlacementMetadata } from '../models/placement-meta-data.model';
import { BpMetricsViewOverlayProperties, BpMetricsViewPlacementProperties } from '@ads-ep/api-metrics';

export const trackPlacementClickEvent = createActionCreator(
  'TRACK_PLACEMENT_CLICK_EVENT', resolve => (payload: {
    domEl: HTMLElement,
    placementConfig: PlacementConfig,
    placementMetaData: PlacementMetadata,
  }) =>
    resolve(payload)
);

export const trackViewPlacementEvent = createActionCreator(
  'TRACK_VIEW_PLACEMENT_EVENT', resolve => (payload: {
    eventData: BpMetricsViewPlacementProperties
  }) => resolve(payload)
);

export const trackViewOverlayEvent = createActionCreator(
  'TRACK_VIEW_OVERLAY_EVENT', resolve => (payload: {
    eventData: BpMetricsViewOverlayProperties
  }) => resolve(payload)
);

export const trackClickOverlayEvent = createActionCreator(
  'TRACK_CLICK_OVERLAY_EVENT', resolve => (payload: {
    eventData: BpMetricsViewOverlayProperties
  }) => resolve(payload)
);